// src/redux/thunks/ai/getTTSHistory.js
import { aiApi } from './ai'

export const gettshistory = aiApi.injectEndpoints({
  endpoints: (builder) => ({
    getTTSHistory: builder.query({
      query: ({ 
        authType, 
        token, 
        limit = 20, 
        offset = 0, 
        status = null, 
        businessId = null,
        sortBy = 'createdAt',
        sortOrder = 'desc'
      }) => {
        const params = new URLSearchParams({
          authType,
          token,
          limit: limit.toString(),
          offset: offset.toString(),
          sortBy,
          sortOrder
        });
        
        if (status) params.append('status', status);
        if (businessId) params.append('businessId', businessId);
        
        return `/tts-history?${params.toString()}`;
      },
      providesTags: ['TTSHistory'],
    }),
    
    getTTSLibrary: builder.query({
      query: ({ 
        authType, 
        token, 
        businessId = null,
        limit = 50,
        category = null
      }) => {
        const params = new URLSearchParams({
          authType,
          token,
          limit: limit.toString()
        });
        
        if (businessId) params.append('businessId', businessId);
        if (category) params.append('category', category);
        
        return `/tts-library?${params.toString()}`;
      },
      providesTags: ['TTSLibrary'],
    }),
    
    downloadTTS: builder.query({
      query: ({ requestId, authType, token }) => `/tts-download/${requestId}?authType=${authType}&token=${token}`,
      providesTags: ['TTSDownload'],
    }),
    
    deleteTTSRequest: builder.mutation({
      query: ({ requestId, authType, token }) => ({
        url: `/tts-request/${requestId}?authType=${authType}&token=${token}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TTSHistory', 'TTSLibrary'],
    }),
  }),
  overrideExisting: false,
});

export const { 
  useGetTTSHistoryQuery, 
  useGetTTSLibraryQuery,
  useGetDownloadTTSQuery,
  useDeleteTTSRequestMutation,
  usePrefetch 
} = gettshistory;